import locationPriorityTemplate from './locationPriority.html';

export default angular
  .module('main.locations.edit.components.priority', [])

  /**
   * Location priority dropdown with autosave feature
   */
  .directive('locationPriority', () => {
    return {
      restrict: 'E',
      template: locationPriorityTemplate,
      scope: {},
      controller: ($scope,
                   $filter,
                   $q,
                   EditLocationDataProvider,
                   config,
                   ToastsService,
                   utils) => {

        const $t = $filter('translate');

        $scope.dataProvider = EditLocationDataProvider.instance;
        let locationPriorities = config.getConfigByKey('locationPriorities');
        let defaultPriorities = locationPriorities.filter(e => e.available);

        angular.extend($scope, {
          getPriorityColor: getPriorityColor,
          applyLocationEmergencyHeaderAction: applyLocationEmergencyHeaderAction
        });

        init();

        function init() {
          $q.all([
            $scope.dataProvider.canIEditLocationResource.init(),
            $scope.dataProvider.locationOrganizationHasFeaturePResource.init(),
            $scope.dataProvider.locationResource.init(),
            $scope.dataProvider.locationHeaderResource.init()
          ])
            .then(() => {
              initLocationPriority();

              $scope.$watch('dataProvider.locationHeaderResource.value', (newVal, oldVal) => {
                initLocationPriority();
              }, true);
            });

          $scope.$watch('selectedPriorityId', (newVal, oldVal) => {
            if (oldVal !== undefined && newVal != oldVal) {
              savePriority();
            }
          });
        }

        function initLocationPriority() {
          const hasFeatureP = $scope.dataProvider.locationOrganizationHasFeaturePResource.value;
          const location = $scope.dataProvider.locationResource.value;
          const canIEditLocation = $scope.dataProvider.canIEditLocationResource.value;

          $scope.showLocationEmergencyHeader = false;
          $scope.showLocationPriority = false;
          $scope.showLocationEmergencyHeaderActions = false;
          $scope.locationEmergencyHeaderActions = [];

          if (!location || !canIEditLocation) {
            return;
          }

          $scope.header = angular.copy($scope.dataProvider.locationHeaderResource.value);

          if ($scope.header) {
            // Init data stream -------------
            $scope.showLocationEmergencyHeader = true;
            $scope.dataStreamAddress = $scope.header.resolution?.datastream_address;
            $scope.locationEmergencyHeaderActions = $scope.header.resolution?.response_options
              ?.filter(ro => !!ro.content && ro.content.answer != null) || [];

            $scope.showLocationEmergencyHeaderActions = !!$scope.header.resolution?.datastream_address
              && $scope.locationEmergencyHeaderActions.length > 0;
          } else if (hasFeatureP) {
            // Init location priority -------------
            $scope.showLocationPriority = true;

            // Get current location priority category
            let locationPriority = locationPriorities.find(e => e.id === location.priorityCategory);
            if (!locationPriority) {
              locationPriority = locationPriorities[0];
            }

            // List available priorities for dropdown
            let availablePriorities = defaultPriorities;
            let listCurrentPriority = availablePriorities.some(e => e.id === locationPriority.id);
            if (!listCurrentPriority) {
              availablePriorities.push(locationPriority);
              availablePriorities.sort((a, b) => a.id - b.id);
            }
            $scope.availablePriorities = availablePriorities;

            $scope.selectedPriorityId = locationPriority.id;
            $scope.locationPriority = {
              ...locationPriority,
              desc: location.priorityComment || $t(locationPriority.desc)
            };
          }
        }

        function resetLocationPriority(rollback) {
          if (rollback) {
            // Rollback dropdown to initial priority
            let initialPriority = $scope.locationPriority.id;
            $scope.selectedPriorityId = initialPriority;
            $scope.dataProvider.locationResource.value.priorityCategory = initialPriority;
          } else {
            // Set new priority
            let currentPriority = $scope.availablePriorities.find(e => e.id === $scope.selectedPriorityId);
            $scope.locationPriority = {
              ...currentPriority,
              desc: $t(currentPriority.desc)
            };
          }
        }

        function savePriority() {
          // Catch the dataProvider loading
          if ($scope.dataProvider.locationResource.loading) {
            resetLocationPriority(true);
            return;
          }
          $scope.loading = true;

          $scope.dataProvider.saveLocationPriority($scope.selectedPriorityId)
            .then(() => {
              resetLocationPriority();
              $scope.loading = false;
              ToastsService.success();
            }, (err) => {
              resetLocationPriority(true);
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }

        function getPriorityColor(priority) {
          if (!priority) {
            return 'grey';
          }
          let currentPriority = locationPriorities.find(el => el.id === priority);
          return currentPriority?.color || 'grey';
        }

        function applyLocationEmergencyHeaderAction(action) {
          if (!action || !action.content || action.content.answer == null || $scope.loading || !$scope.showLocationEmergencyHeaderActions) {
            return;
          }
          $scope.loading = true;
          $scope.dataProvider.applyEmergencyHeaderAction(action)
            .then(() => {
              $scope.loading = false;
              ToastsService.success();
              // TODO show more detailed message
              // TODO websocket subscription
            }, (err) => {
              $scope.loading = false;
              utils.handleApiError(err);
            });
        }
      }
    };
  })
  .name;
